import { Select, MenuItem } from '@mui/material'
import Field from 'components/ui/Field'
import { DocType } from 'config'
import { UserGroupConfig, Mode } from 'types'

import DocTypeSelector from './DocTypeSelector'
import ImportTypeRadioGroup from './ImportTypeRadioGroup'
import { DocTypeOption, SelectHandler, RadioGroupChangeHandler } from './types'

interface Props {
  mode: Mode
  docTypeOptions: DocTypeOption[]
  docType: DocType | null
  onDocTypeSelect: (value: string) => void
  ocrBuilderID: number | null
  onOcrBuilderIDChange: (id: number | null) => void
  group: string
  groupOptions: string[]
  onGroupSelect: SelectHandler
  groupDisabled: boolean
  importType: string
  disableImportType: boolean
  onImportTypeSelect: RadioGroupChangeHandler
  userGroupConfig: UserGroupConfig
}

const SettingArea = (props: Props) => {
  const {
    mode,
    docTypeOptions,
    docType,
    onDocTypeSelect,
    ocrBuilderID,
    onOcrBuilderIDChange,
    group,
    groupOptions,
    onGroupSelect,
    groupDisabled,
    importType,
    disableImportType,
    onImportTypeSelect,
    userGroupConfig,
  } = props

  const labelWidth = 150
  const showImportType = userGroupConfig.useInvoiceOCR || userGroupConfig.useOrderForm

  const groupItems = groupOptions.map((option) => (
    <MenuItem key={option} value={option}>
      {option}
    </MenuItem>
  ))

  return (
    <div>
      <DocTypeSelector
        mode={mode}
        labelWidth={labelWidth}
        onChange={onDocTypeSelect}
        docTypeOptions={docTypeOptions}
        docType={docType}
        ocrBuilderID={ocrBuilderID}
        onOcrBuilderIDChange={onOcrBuilderIDChange}
        userGroupConfig={userGroupConfig}
      />

      {showImportType && (
        <Field inline divider label="読取り方式" labelWidth={labelWidth}>
          <ImportTypeRadioGroup
            value={importType}
            onChange={onImportTypeSelect}
            disabled={disableImportType}
          />
        </Field>
      )}

      <Field inline divider label="保存グループ" labelWidth={labelWidth}>
        <Select
          fullWidth
          size="small"
          value={group}
          onChange={onGroupSelect}
          variant="outlined"
          margin="dense"
          displayEmpty
          disabled={groupDisabled}
          data-testid="save-group"
        >
          <MenuItem value="">選択してください</MenuItem>
          {groupItems}
        </Select>
      </Field>
    </div>
  )
}

export default SettingArea
